export default {"src":"/_next/static/media/reach_icon_rgb_black.717fe915.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};